// src/components/ForgotPasswordChatbot.jsx

import React, { useState } from 'react';
import './ForgotPasswordChatbot.css';
import { motion } from 'framer-motion';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import chatbotImg from '../assets/chatbot.png';
import userImg from '../assets/user.png';
import BASE_URL from '../config'; 
import axios from 'axios';

export default function ForgotPasswordChatbot({ onClose }) {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: 'bot',
      text: '👋 Hello! I will assist you in creating a new password. Please enter the email address you previously used.'
    }
  ]);
  const [done, setDone] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();

    if (step === 0 && email) {
      setMessages(prev => [...prev, { from: 'user', text: email }]);
      setMessages(prev => [...prev, { from: 'bot', text: 'Thanks! Please type your new password. Make sure it’s strong and secure.' }]);
      setStep(1);
    }

    else if (step === 1 && newPassword) {
      setMessages(prev => [...prev, { from: 'user', text: '••••••••' }]);
      setMessages(prev => [...prev, { from: 'bot', text: 'Please confirm your new password.' }]);
      setStep(2);
    }

    else if (step === 2 && confirmPassword) {
      setMessages(prev => [...prev, { from: 'user', text: '••••••••' }]);

      if (newPassword !== confirmPassword) {
        setMessages(prev => [
          ...prev,
          { from: 'bot', text: '❌ Passwords do not match. Please try again from the beginning.' }
        ]);
        setStep(0);
        setEmail('');
        setNewPassword('');
        setConfirmPassword('');
        return;
      }

      try {
        await axios.put(`${BASE_URL}/account/forgot-password`, {
          email: email.trim().toLowerCase(),
          new_password: newPassword
        });

        setMessages(prev => [
          ...prev,
          { from: 'bot', text: '✅ New Password Created Successfully!' }
        ]);
        setDone(true);
        setTimeout(() => onClose(), 3000);
      } catch (error) {
        if (error.response?.status === 404) {
          setMessages(prev => [
            ...prev,
            { from: 'bot', text: '⚠️ No Email Address Specified Found. Please check your email and try again.' }
          ]);
          setTimeout(() => onClose(), 3000); // ✅ Close after 3 seconds if email not found
        } else {
          setMessages(prev => [
            ...prev,
            { from: 'bot', text: '❌ Error occurred. Please try again or contact support.' }
          ]);
        }
      }
    }
  };

  return (
    <motion.div className="chatbot-container" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }}>
      <div className="chatbot-header">
        Forgot Password Assistant
        <button onClick={onClose}>×</button>
      </div>
      <div className="chatbot-messages">
        {messages.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.from}`}>
            <img src={msg.from === 'bot' ? chatbotImg : userImg} alt="avatar" />
            <p>{msg.text}</p>
          </div>
        ))}
      </div>

      {!done && (
        <form className="chatbot-input" onSubmit={handleSend}>
          {step === 0 && (
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Your Email"
              required
            />
          )}

          {step === 1 && (
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="New Password"
                required
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          )}

          {step === 2 && (
            <div className="password-field">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                required
              />
              <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          )}

          <button type="submit">Send</button>
        </form>
      )}
    </motion.div>
  );
}
